import { listAllGoals, updateGoalMutation } from '@akin-home/goals/frontend';
import { goalGraphqlToModel } from './../../../../../../../libs/goals/frontend/src/lib/functions/goalGraphqlToModel';
import { createChatTextItem } from './../../ChatItem/functions';
/** Processes the incrementing of a goal from a command */

import { UserModel } from '$tablet-app/src/app/auth/UserModel';
import { ChatItem } from '$tablet-app/src/app/chat/ChatItem/types';
import { incrementGoalCompletion } from '$tablet-app/src/app/goals/functions';
import { Goal } from '@akin-home/goals';
import { QueryClient } from 'react-query';
import { UpdateGoalCommand } from '../types';

interface Params {
  /** The increment goal command */
  command: UpdateGoalCommand;

  /** The currently logged in user */
  user: UserModel;

  /** Query client to be used to invalidate the data cache */
  queryClient?: QueryClient;

  /** Function to add an item to the chat */
  addItem?: (item: ChatItem | ChatItem[]) => void;
}

const processIncrementGoalCommand = async ({
  command,
  user,
  queryClient,
  addItem,
}: Params) => {
  /** Query the goal by reference code */
  const {
    data: { reference_code, success_message, title },
  } = command;

  const user_id = user.id;

  if (!reference_code && !title) return;

  const all_goals = await listAllGoals({ query: { name: title } });

  if (!all_goals.length) return;

  let filtered_goals = all_goals.map(goalGraphqlToModel) as Goal[];

  if (reference_code) {
    filtered_goals = filtered_goals.filter(
      (goal) => goal.reference_code === reference_code
    );
  }

  if (!filtered_goals.length) return;

  /** Goal found, increment goal for given user */
  filtered_goals.forEach(async (goal) => {
    const updatedGoal = incrementGoalCompletion(goal, {
      user_id,
      date: new Date(),
    });

    const completions = JSON.stringify(updatedGoal.completions);

    const input = {
      id: updatedGoal.id,
      completions,
    };

    await updateGoalMutation({
      input,
    });
  });

  queryClient?.invalidateQueries('goals');

  /** Success message exists, add as text item */

  if (success_message && addItem) {
    addItem(
      createChatTextItem({
        data: {
          text: success_message,
          source: 'server',
        },
      })
    );
  }
};

export default processIncrementGoalCommand;
